<div *ngIf="showField()" class="form-component-input-group">
  <app-field-header
    *ngIf="!model.isInsideRepeatable"
    [model]="model"
    [disabled]="isInputHidden()"></app-field-header>
  <div class="input-group-addon" *ngIf="!isInputHidden()">
    <app-select
      [control]="control"
      [options]="options"
      [isMandatory]="model.isMandatory"
      [isReadonly]="model.isReadonly"
      [hasError]="hasInputError()"
      [htmlId]="htmlId"
      [ariaLabel]="model.translatedLabel"></app-select>
  </div>
  <app-forbidden-info
    [model]="model"
    [userSettings]="userSettings"
    *ngIf="isInputHidden()"></app-forbidden-info>
  <app-validation-message [model]="model"></app-validation-message>
</div>
